import Button from '@mui/material/Button';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ApplicationModal } from '@/components/organisms/ApplicationModal';
import { useTranslator } from '@/hooks/useTranslator';

export const InternalTransferCompleted: React.FC = (): React.ReactElement => {
  const tr = useTranslator();
  const navigate = useNavigate();

  const goToDashboard = React.useCallback((): void => {
    navigate('/home');
  }, [navigate]);

  return (
    <ApplicationModal
      variant="prominent"
      title={tr('INTERNAL_TRANSFER_COMPLETED')}
      description={tr('INTERNAL_TRANSFER_COMPLETED_DESCRIPTION')}
      onClose={goToDashboard}>
      <Button variant="dark" fullWidth={true} onClick={goToDashboard}>
        {tr('DONE')}
      </Button>
    </ApplicationModal>
  );
};
